<script>
  import Bandit from "./Bandit.svelte";
  import LineWorld from "./LineWorld.svelte";
  import GridWorld from "./GridWorld.svelte";
</script>

<h1 class="body-header">Simulation</h1>

<p class="body-text">
  Let's see reinforcement learning in action! We'll walk through a scenario with
  a robot learning to find bananas.
</p>

<Bandit />

<LineWorld />

<GridWorld />

<style>
  :global(body) {
    margin-top: 60px;
    margin-bottom: 60px;
  }
</style>
